'use client';

import { useEffect } from 'react';

export const GTMConsent: React.FC = () => {
  useEffect(() => {
    const handleGTMConsent = (hasAnalyticsConsent: boolean) => {
      if (window?.dataLayer) {
        // Push consent update to dataLayer
        window.dataLayer.push({
          event: 'consent_update',
          ad_storage: hasAnalyticsConsent ? 'granted' : 'denied',
          analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied',
          ad_user_data: hasAnalyticsConsent ? 'granted' : 'denied',
          ad_personalization: hasAnalyticsConsent ? 'granted' : 'denied',
          functionality_storage: hasAnalyticsConsent ? 'granted' : 'denied',
          personalization_storage: hasAnalyticsConsent ? 'granted' : 'denied',
          security_storage: hasAnalyticsConsent ? 'granted' : 'denied',
        });
      }
    };

    const handleAcceptAll = () => handleGTMConsent(true);
    const handleAccept = () => handleGTMConsent(true);
    const handleReject = () => handleGTMConsent(false);
    const handlePerformanceCategory = () => handleGTMConsent(true);

    // Listen for CookieScript events
    window.addEventListener('CookieScriptAcceptAll', handleAcceptAll);
    window.addEventListener('CookieScriptAccept', handleAccept);
    window.addEventListener('CookieScriptReject', handleReject);
    window.addEventListener('CookieScriptCategory-performance', handlePerformanceCategory);

    // Cleanup function
    return () => {
      window.removeEventListener('CookieScriptAcceptAll', handleAcceptAll);
      window.removeEventListener('CookieScriptAccept', handleAccept);
      window.removeEventListener('CookieScriptReject', handleReject);
      window.removeEventListener('CookieScriptCategory-performance', handlePerformanceCategory);
    };
  }, []);

  return null;
};

// Extend Window interface for gtag
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}
